import { render } from "./UserFeedCard.vue?vue&type=template&id=3d1bec2a&scoped=true"
import script from "./UserFeedCard.vue?vue&type=script&lang=js"
export * from "./UserFeedCard.vue?vue&type=script&lang=js"

import "./UserFeedCard.vue?vue&type=style&index=0&id=3d1bec2a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d1bec2a"]])

export default __exports__